import React, { useState } from "react";
import Asterisk from "../../utils/Asterisk";
import { useFormCtx } from "../../../context/formContext/formContext";

const WebsiteInput = ({
  htmlFor,
  label,
  required,
  type,
  name,
  relative,
  top,
  inputColor,
  value,
  placeholder,
}) => {
  const { fillCoporateInfo } = useFormCtx();
  const [error, setError] = useState("");

  const urlRegex = /^https:\/\/[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(\/.*)?$/;

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Validate URL format
    if (name === "websiteURL") {
      if (!value) {
        setError(required ? "This field is required." : "");
      } else if (!urlRegex.test(value)) {
        setError("Please enter a valid URL starting with https://");
      } else {
        setError(""); // Clear error if valid
      }
    }

    fillCoporateInfo(e);
  };

  return (
    <div className={`form-group ${relative} ${top} w-full md:w-1/2`}>
      <div className="flex flex-col">
        <label htmlFor={htmlFor} className="flex items-center">
          <span
            className={`font-bold ${inputColor ? "text-white" : "text-black"}`}
          >
            {label}
          </span>
          <span>
            <Asterisk required={required} />
          </span>
        </label>

        <input
          type={type}
          name={name}
          value={value || ""}
          className={`border ${
            error ? "border-red-500" : "border-black"
          } w-full outline-none rounded-xl py-3 px-4 font-bold text-black`}
          onChange={handleChange}
          required={required}
          placeholder={placeholder}
        />

        {error && <span className="text-red-500 text-sm mt-1">{error}</span>}
      </div>
    </div>
  );
};

export default WebsiteInput;
